import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const containerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	flex: 1;
	min-height: 0;

	/* Below the compact breakpoint the whole page scrolls here; the tab bar sticks to this container. */
	@media (max-width: ${theme.layout.compactBreakpoint}) {
		overflow-y: auto;
	}
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The outer box of a dossier screen. */
const SubjectScreenContainer: React.FC<Props> = ({ children }) => {
	return <div css={containerStyle}>{children}</div>;
};

export default SubjectScreenContainer;
